define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"./Number"
], function(array,declare,NumberRen) {

	return declare(NumberRen, {
		// String: css classes to use for (off) base size column (with leading space)
		//cssBaseSize: " base",
		//cssOffBaseSize: " nonBase",

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: blank out numbers off base size if Blanks is set
			var	value = this.toValue(ctx, h);
			var	scd = ctx.getNodeParent();
			
			if (scd.Blanks && !this._isBaseSize(ctx)) {
				value = "";
			}

			refNode.innerHTML = value;
			return true;
		},
		
		_getRenderCSS: function(/*Context*/ctx, /*Heading*/h) {
			// summary: if value is different than target, then show as editable override; otherwise show as editable with expression
			return (this.inherited(arguments) || "") + (this._isBaseSize(ctx) ? this.cssBaseSize : this.cssOffBaseSize);
		},
		
		_isBaseSize: function(/*Context*/ctx) {
			// summary: determine if size being reviewed is base size
			var	scrd = ctx.getNode();
			var	ranges = ctx.view.getSubSizeRangeData(scrd);
			var	index = ctx.cache.getNode(scrd.ReviewSize).SizeIndex;
			return ranges.isBaseIndex(index);
		}
	});
});